import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const UsageScreenContext = /*#__PURE__*/createContext({
  screen: undefined,
  subscreen: undefined
});
export function UsageScreenProvider({
  children,
  screen,
  subscreen
}) {
  const {
    screen: currentScreen,
    subscreen: currentSubscreen
  } = useUsageScreen();
  return /*#__PURE__*/_jsx(UsageScreenContext.Provider, {
    value: {
      screen: screen !== null && screen !== void 0 ? screen : currentScreen,
      subscreen: subscreen !== null && subscreen !== void 0 ? subscreen : currentSubscreen
    },
    children: children
  });
}
export function useUsageScreen() {
  return useContext(UsageScreenContext) || {};
}